
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/joy-ui/customization/right-to-left",
      function () {
        return require("private-next-pages/joy-ui/customization/right-to-left.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/joy-ui/customization/right-to-left"])
      });
    }
  